import { useCallback } from 'react';
import useAjax from '@apis/useAjax';
import { POST_CLUB_INSPECTION_ORDER_API } from '@apis/apiPath';

/**
 * 店鋪驗貨單相關 API Hook
 * 對應後端 ClubInspectionOrderController
 */
const useClubInspectionOrderApi = () => {
    const Ajax = useAjax();

    /**
     * 新增驗貨單
     * @param {object} params 驗貨單資訊 (ClubInspectionOrderRequestModel)
     * @returns {Promise<{ inspectionID: number|null, completedOrder: boolean }>} ClubInspectionOrderCompleteResponseModel（JSON 為 camelCase）
     */
    const postClubInspectionOrderApi = useCallback(
        async (params) => await Ajax.post(POST_CLUB_INSPECTION_ORDER_API, params),
        // eslint-disable-next-line
        [],
    );

    return {
        postClubInspectionOrderApi,
    };
};

export default useClubInspectionOrderApi;
